import DragObject from './drag-object.js';
import Region from './region.js';
import ActionDrag from './action-drag.js';
import SlideManager from "../utils/slide-manager";

class ActionDragToRegion {
    constructor(object, regions, pointerPos) {
        this._object = object;
        this._regions = regions;

        this._startObjectPos = object.getPosition();
        this._dragAction = new ActionDrag(object, pointerPos);

        this._status = 'in-progress';
        this._promise = new Promise((resolve, reject) => {
            this._resolvePromise = resolve;
        });

        this._dragAction.promise.then(this._endDragging.bind(this));
    }

    movePointer(pointerPos) {
        this._dragAction.movePointer(pointerPos);
    }

    cancel() { this._dragAction.cancel(); }
    finish() { this._dragAction.finish(); }

    _endDragging({ status, position }) {
        switch (status) {
            case 'cancelled':
                this._status = 'cancelled';
                this._resolvePromise({ status: 'cancelled', object: this._object });
                break;
            case 'finished':
                let size = this._object.getSize();
                let midPos = {
                    x: position.x+size.x*0.5,
                    y: position.y+size.y*0.5,
                };
                let region = this._getRegionAtPoint(midPos);
                if (region) {
                    if(Q3.data.slides[SlideManager.activeSlide].slideQuiz.use2DSnapping) {
                        let regPos = region.getMidPosition();
                        let newPos = {
                            x: regPos.x - size.x * 0.5,
                            y: regPos.y - size.y * 0.5,
                        }
                        this._object.setPosition(newPos);
                    }
                    this._status = 'finished';
                    this._resolvePromise({ status: 'finished', region: region, object: this._object });
                } else {
                    this._object.setPosition(this._startObjectPos);
                    this._status = 'reset';
                    this._resolvePromise({ status: 'reset', object: this._object });
                }
                break;
            default:
                throw new Error('unknown status: '+status);
        }
    }

    _getRegionAtPoint(position) {
        for (let region of this._regions) {
            if (region.isPointInside(position)) {
                return region;
            }
        }

        return null;
    }

    get promise() { return this._promise; }
    get status() { return this._status; }
}

export default ActionDragToRegion;
